import { DsmAddendumEnvelope } from '../models/dsm-addendum-sign-off.models';

export function dsmEnvelopeLabel(envelope: Pick<DsmAddendumEnvelope, 'envelopeId' | 'dealDocumentId'>): string {
  const source = envelope.envelopeId || envelope.dealDocumentId || '';
  const compact = source.replace(/-/g, '');
  return compact ? `ENV-${compact.slice(-6).toUpperCase()}` : 'Envelope';
}
